import React from 'react';

interface Props {
  text: string;
  alert?: boolean;
  testID?: string;
}

export const MatchLabel: React.FC<Props> = ({
  text,
  alert = false,
  testID = 'DefaultMatchLabel',
}) => {
  return (
    <div
      className={`flex items-center m-0 rounded-xl pr-2 float-right ${
        alert ? 'bg-red-500' : 'bg-blue-200'
      } `}
    >
      <p className="text-center text-xs font-extrabold ml-2 my-1 text-white" data-testid={testID}>
        {text}
      </p>
    </div>
  );
};
